'use client';
import React from 'react';
import styled from '@benzinga/themetron';
import { QuoteBox } from '../QuoteBox';
import { DelayedQuote } from '@benzinga/quotes-manager';
import { StockSymbol } from '@benzinga/session';
interface QuotesListProps {
  quotes?: Record<StockSymbol, DelayedQuote> | null;
  tickers?: string[];
}

export const QuotesList: React.FC<QuotesListProps> = ({ quotes, tickers }) => {
  const getQuote = React.useCallback(
    ticker => {
      if (quotes?.[ticker] && !quotes?.[ticker]?.error) {
        return quotes[ticker];
      }

      return null;
    },
    [quotes],
  );

  return (
    <QuoteListWrapper className="quote-list-wrapper">
      {tickers &&
        tickers?.map((ticker, i: number) => {
          return <QuoteBox key={i} quote={getQuote(ticker)} />;
        })}
    </QuoteListWrapper>
  );
};

const QuoteListWrapper = styled.div`
  display: flex;
  flex-grow: 1;
  height: 52px;
`;
